global.jQuery = require('jquery');
global.$ = jQuery;

import ajaxCart from './components/ajax-cart';
import homePage from './pages/home';
import productPage from './pages/product';
import collectionPage from './pages/collection';
import artistsPage from './pages/artists';
import Cart from './pages/cart';
import shopifyMoney from './extra/money';
import Wishlist from './components/wishlist';

const { detect } = require('detect-browser');
const browser = detect(); 

var ipadOS = navigator.maxTouchPoints &&
navigator.maxTouchPoints > 2 &&
/MacIntel/.test(navigator.platform);
 
global.isTouch = (('ontouchstart' in window) ||
(navigator.maxTouchPoints > 0) ||
(navigator.msMaxTouchPoints > 0));

const colourOptions = [
    '#d7d029',
    '#7fb6d9',
    '#ff4841',
    '#46ba67',
    '#eb88c8',
    '#ff7600'
];

if(ipadOS) {
    $('html').addClass('ipados');
}

if (browser) {
    let b = browser.name.replace(' ','').toLowerCase();
    $('html').addClass(b);
    $('html').addClass(`${b}_${browser.version}`);
    $('html').addClass(`${b}_${browser.os.replace(' ','').toLowerCase()}`);
}
  

$(() => {
    console.log('ok');

    $('.search-container button').on('click', function(e){
        if($('.search-input').val() == '') {
            e.preventDefault();
        }
    });

    let popLocal = localStorage.getItem('www-newsletterpopup');
    let now = Date.now();
    let hours48 = 48 * 60 * 60 * 1000; // 48 hours in milliseconds
    let popLoop = null;

    // Check if the popup should be shown
    if(popLocal!=='never') {
        if (!popLocal || (now - parseInt(popLocal)) > hours48) {
            popLoop = setInterval(function () {
                if($('#Avada-CookiesBar').children('div').length == 0) {
                    clearInterval(popLoop);
                    $('#newsltr-popup').addClass('in');
                }
            }, 10000);
        }
    }

    $('.newsltr-popup--close').on('click', function(e){
        e.preventDefault();
        localStorage.setItem('www-newsletterpopup', Date.now());
        $('#newsltr-popup').removeClass('in');
    });

    $('#newsltr-popup .klaviyo-form').on('submit', function(){
        localStorage.setItem('www-newsletterpopup', 'never');
    });

    const money = new shopifyMoney();
    money.init();

    if($('.template-cart').length>0) {
        new Cart();
    } else {
        let c = new ajaxCart;
        c.init();
    }

    $('.darkmode-toggle').on('click', function(e){
        e.preventDefault();
        $('html').toggleClass('dark');
        localStorage.setItem('darkmode', $('html').hasClass('dark'));
        $(this).children('i').toggleClass('cur');
    });

    if(localStorage.getItem('darkmode')=='true') {
        $('html').addClass('dark');
        $('.darkmode-toggle').children('i').toggleClass('cur');
    }


    // page types
    if($('.template-index').length>0) {
        const page = new homePage();
        page.init();
    }


    if($('.template-suffix-artists').length>0) {
        const page = new artistsPage();
    }

    if(
        $('.template-collection').length>0 ||
        $('.template-search').length>0
    ) {
        const page = new collectionPage();
        page.init();

        if($('.template-suffix-artist').length>0) {
            let borderLeft = Math.random() > 0.5 ? 'left' : 'right';
            if(borderLeft == 'left') {
                $('.name img').css({
                    'border-left': `6px solid ${colourOptions[Math.floor(Math.random()*colourOptions.length)]}`
                });
            } else {
                $('.name img').css({
                    'border-right': `6px solid ${colourOptions[Math.floor(Math.random()*colourOptions.length)]}`
                });
            }
        }

        $('[href="#works"]').on('click', function(e){
            e.preventDefault();
            $('html, body').animate({
                scrollTop : $('#works').offset().top - 100
            }, 500);
        });
    }

    setTimeout(() => {
        window.wishlist = new Wishlist();
        wishlist.init();
    }, 100);

    if($('.template-product').length>0) {
        const page = new productPage();
        page.init();
    }

    document.querySelector('.hypno').addEventListener('click', () => {
        document.querySelector('html').classList.toggle('hypno');
        $('.hypno-text').remove();
        if($('html').hasClass('hypno')){
            $('html').append('<div class="hypno-text"><span>OLET NYT TAIDEHYPNOOSISSA</span><span>OLET NYT TAIDEHYPNOOSISSA</span><span>OLET NYT TAIDEHYPNOOSISSA</span></div>');
        }
    });


    if($('.content-nav').length>0) {
        $('.default-page > ol > li').each(function(){
            // generate slug
            let slug = $(this).text().toLowerCase().replaceAll(/ /g, '').replaceAll('\n','');
            $(this).attr('id', slug);
            // create nav
            $('.content-nav').append(`<a href="#${slug}">${$(this).text()}</a>`);
        });
        $('.content-nav a').on('click', function(e){
            e.preventDefault();
            let target = $(this).attr('href');
            $('html, body').animate({
                scrollTop : $(target).offset().top - 100
            }, 500);
        });
    }

    if($('.template-suffix-artists').length>0) {
        $('h2.name').on('mouseenter', function(){
            let opts = [
                '#d7d029',
                '#7fb6d9',
                '#ff4841',
                '#46ba67',
                '#eb88c8',
                '#ff7600'
            ];
            let rnd = opts[Math.floor(Math.random()*opts.length)];
            let borderLeft = Math.random() > 0.5 ? 'left' : 'right';
            if(borderLeft == 'left') {
                $(this).find('img').css({
                    'border-left': `3px solid ${rnd}`
                });
            } else {
                $(this).find('img').css({
                    'border-right': `3px solid ${rnd}`
                });
            }
        }).on('mouseleave', function(){
            $(this).find('img').css({
                'border' : ''
            });
        });
    }

    initView();

    miscBinds();

    resize();
    
    $(window).on('resize', resize);
});

function miscBinds(){
    $('.menu-toggle').on('click', function(e){
        e.preventDefault();
        $('#shopify-section-header').toggleClass('tog');
    });

    $('p.the-giftcard--code').on('click', function(){
        // copy text
        let text = $(this).text();
        let input = document.createElement('input');
        input.value = text;
        document.body.appendChild(input);
        input.select();
        document.execCommand('copy');
        document.body.removeChild(input);
        $(this).addClass('copied');
        setTimeout(() => {
            $(this).removeClass('copied');
        }, 80);
    });

}

function initView(){
    $('.grid__item').each(function(){
        $(this).css({
            'top' : `${Math.random()*6}rem`,
            'left' : `${Math.random()*8 - 4}rem`
        });
    });
}

function resize(){
    window.w = window.innerWidth;
    if(window.prev_w == window.w && isTouch) return;
    let vh = window.innerHeight * 0.01;
    window.vh = vh;
    document.documentElement.style.setProperty(`--vh`, `${vh}px`);
    window.prev_w = window.innerWidth;
}